module.exports = __webpack_public_path__ + "img/horizontal_6_4_pp1_3016.7d834a16.png";